// The hero location panel's "Recent" list (design `recentLocs`, max 3): the last
// places this visitor picked, newest first. A per-browser convenience, so it lives in
// localStorage — and every access is guarded, because storage can be blocked (private
// windows, disabled site data) and the panel must still work without it.
const KEY = 'bd.recent_locations';
const MAX = 3;

// Entries are registry location ids (a city or an area).
export function readRecentLocations(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string').slice(0, MAX) : [];
  } catch {
    return [];
  }
}

// Puts `id` first, drops an older copy of it, keeps at most three.
export function pushRecentLocation(list: string[], id: string): string[] {
  return [id, ...list.filter((x) => x !== id)].slice(0, MAX);
}

export function saveRecentLocations(list: string[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* storage unavailable — the list just does not persist */
  }
}
